var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7149 7.17969C13.7945 7.17969 15.2703 6.84277 16.2891 6.45703C15.8906 4.51953 15.0899 2 13.8047 2C13.3996 2 13.0383 2.17578 12.7356 2.41016C12.4453 2.63594 12.0977 2.74727 11.75 2.75352C11.4024 2.74727 11.0547 2.63594 10.7656 2.41016C10.461 2.17578 10.1016 2 9.69533 2C8.41408 2 7.60939 4.51953 7.1758 6.45703C8.19533 6.84375 9.66798 7.17969 11.7149 7.17969ZM11.75 12C15.918 12 19.418 9.36602 20.4649 6.57422C20.5723 6.27637 20.4282 5.95156 20.1256 5.81484C19.8278 5.67813 19.4689 5.76359 19.2689 6.02234C19.2347 6.07117 17.4865 8.42977 11.7494 8.42977C6.01228 8.42977 4.26525 6.07422 4.23126 6.02344C4.03087 5.76484 3.67462 5.67695 3.37685 5.81367C3.07412 5.95039 2.92763 6.27773 3.03509 6.57539C4.08048 9.36719 7.58205 12 11.75 12ZM16.0469 17H7.45314C5.36564 17 3.54298 18.4211 3.03908 20.4469C2.84205 21.2344 3.43712 22 4.25001 22H19.2149C20.0277 22 20.6246 21.2359 20.4274 20.4469C19.957 18.4219 18.1367 17 16.0469 17Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.7148 10.75C16.7148 13.5113 14.4766 15.75 11.75 15.75C9.02344 15.75 6.75 13.5156 6.75 10.7539C6.75 10.7158 6.76034 10.6763 6.76118 10.6384C8.19141 11.4609 9.89844 12 11.75 12C13.6016 12 15.3066 11.4617 16.7383 10.6387C16.7383 10.6758 16.7148 10.7109 16.7148 10.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClients);
export default __webpack_public_path__ + "static/media/icon-clients.0c37392b718f46e2d2f83d99df64ae8c.svg";
export { ForwardRef as ReactComponent };